import { NatureCustomFieldDto } from '../interfaces';

/**
 * Types each search params coming for the url split
 * and morphs it into its real type : boolean, number,...
 * Be careful the order of the 'ifs' is crucial
 * We need to check if it's ExpediteurIdiAdmins BEFORE checking if it's a number. one is an array the other a number; same for the complementary datas
 * @example
 * IsAdvancedSearch: "true"
 * ==> IsAdvancedSearch: true
 * @param queryParamsAsObject `KeyValue<string, string>`
 * @returns `KeyValue<string, unknown>` unknown will be the correct type
 */
export function searchParamsConverterByType(
  queryParamsAsObject: { [key: string]: unknown },
  listOfNatures: {
    label: string;
    value: number;
    natureCustomFields: NatureCustomFieldDto[];
  }[]
): { [key: string]: unknown } {
  const listOfCustomFields = [];
  Object.keys(queryParamsAsObject).map((key) => {
    if (key === 'DestinataireIdiAdmins' || key === 'ExpediteurIdiAdmins' || key.includes('Ids'))
      queryParamsAsObject[key] = (queryParamsAsObject[key] as string).split(',').map((x) => +x);
    else if (queryParamsAsObject[key] === 'false') queryParamsAsObject[key] = false;
    else if (queryParamsAsObject[key] === 'true') queryParamsAsObject[key] = true;
    else if (queryParamsAsObject[key] === 'null') queryParamsAsObject[key] = null;
    else if (queryParamsAsObject[key] === 'undefined') queryParamsAsObject[key] = undefined;
    else if (key.includes('NCFS')) {
      // la on est dans les données complémentaires liées à une nature.

      listOfCustomFields.push(convertComplementaryData({ [key]: queryParamsAsObject[key] }, queryParamsAsObject['NatureIds'][0], listOfNatures));
    } else if (!isNaN(+queryParamsAsObject[key])) queryParamsAsObject[key] = +queryParamsAsObject[key];
    else return [key, queryParamsAsObject[key]]; // il peut juste être un string donc on le return simplement
  });
  if (listOfCustomFields.length > 0) queryParamsAsObject = { ...queryParamsAsObject, NatureCustomFieldsSearch: listOfCustomFields };
  Object.keys(queryParamsAsObject).map((key) => {
    if (key.includes('NCFS')) delete queryParamsAsObject[key];
  });

  return queryParamsAsObject;
}

export function convertComplementaryData(
  complementaryData: { [key: string]: unknown },
  natureId: number,
  listOfNatures: {
    label: string;
    value: number;
    natureCustomFields: NatureCustomFieldDto[];
  }[]
): { [key: string]: unknown } {
  /*
   * On a forcément la nature, sinon on aurait pas de données. De plus, si on a une donnée complémentaire alors on a forcément qu' UNE seule nature : règle métier.
   * La variable est composée de 3 parties:
   * 'NCFS' : Nature Custom Field Search qui est le nom de base de la méta donnée envoyée par la recherche avancée
   * _{{number}} : l'id de la donnée complémentaire dans la db (colonne). Cet id est unique et n'est PAS celui qui gère le type de donnée complémentaire (ex : 1 pour checkbox)
   * La value après le = qui est ce que l'utilisateur a encodé. Attention, cela peut être le textValue; dateValue,... il faudra faire en fonction du type de donnée complémentaire.
   * Attention cette dernière value a été envoyée en encodage : encodeURIComponent => elle doit donc être décodée afin d'être lue correctement.
   */

  // 1ere étape, récupérer la nature complémentaire complète ainsi que la donnée complémentaire
  const fullNature = listOfNatures.find((nature) => nature.value === natureId);
  const customFieldId = +Object.keys(complementaryData)[0].split('_')[1];
  const rightCustomField = fullNature.natureCustomFields.find((customField) => customField.id === customFieldId);
  const customNatureToSendBack: {
    id: number;
    natureCustomFieldId: number;
    natureId: number;
    type: string;
    label: string;
    textValue?: string;
    textareaValue?: string;
    dateValue?: string;
    numberValue?: number;
    decimalValue?: number;
    listValueItemId?: number[];
  } = {
    id: rightCustomField.id,
    natureCustomFieldId: rightCustomField.customFieldId,
    natureId: rightCustomField.natureId,
    type: rightCustomField.customField.type.toLowerCase(),
    label: rightCustomField.name,
  };

  // Ensuite en fonction du type de donnée complémentaire, on va lui sa valeur
  switch (rightCustomField.customField.type.toLowerCase()) {
    case 'text':
      customNatureToSendBack.textValue = decodeURIComponent(complementaryData[Object.keys(complementaryData)[0]] as string);
      break;
    case 'date':
      customNatureToSendBack.dateValue = decodeURIComponent(complementaryData[Object.keys(complementaryData)[0]] as string);
      break;
    case 'checkbox':
      customNatureToSendBack.numberValue = 1;
      break;
    case 'decimal':
      customNatureToSendBack.decimalValue = +decodeURIComponent(complementaryData[Object.keys(complementaryData)[0]] as string);
      break;
    case 'integer':
      customNatureToSendBack.numberValue = +decodeURIComponent(complementaryData[Object.keys(complementaryData)[0]] as string);
      break;
    case 'textarea':
      customNatureToSendBack.textValue = decodeURIComponent(complementaryData[Object.keys(complementaryData)[0]] as string);
      customNatureToSendBack.textareaValue = decodeURIComponent(complementaryData[Object.keys(complementaryData)[0]] as string);
      break;
    case 'dropdown':
      customNatureToSendBack.listValueItemId = decodeURIComponent(complementaryData[Object.keys(complementaryData)[0]] as string)
        .split(',')
        .map((listValueItemId) => +listValueItemId)
        .filter((listValueItemId) => listValueItemId > 0);
      break;
  }

  return customNatureToSendBack;
}
